import {Box, Drawer, List, ListItemButton, Stack, styled, Theme, Tooltip, useMediaQuery,} from "@mui/material";
import {FC, useState} from "react";
import {useNavigate, useSearchParams} from "react-router-dom";
import ScrollBar from "simplebar-react";
import topMenuList from "./topMenuList";
import {H4} from "../Typography";
import {useAppDispatch} from "../../hooks/useRedux";

// root component interface
interface SideNavBarProps {
    showMobileSideBar: boolean;
    closeMobileSideBar: () => void;
}

// custom styled components
const MainMenu = styled(Box)(({theme}) => ({
    left: 0,
    width: 250,
    height: "100%",
    position: "fixed",
    boxShadow: theme.shadows[2],
    transition: "left 0.3s ease",
    zIndex: theme.zIndex.drawer + 11,
    backgroundColor: theme.palette.background.paper,
    [theme.breakpoints.down("md")]: {left: -80},
    "& .simplebar-track.simplebar-vertical": {width: 7},
    "& .simplebar-scrollbar:before": {
        background: theme.palette.text.primary,
    },
}))

const StyledListItemButton = styled(ListItemButton)(() => ({
    marginBottom: "1rem",
    justifyContent: "center",
    marginLeft: 8,
    marginRight: 8,
    borderRadius: 8,
}))

// root component
const DashboardSideBar: FC<SideNavBarProps> = ({showMobileSideBar, closeMobileSideBar,}) => {
    const navigate = useNavigate()
    const url=new URL(window.location.href)
    const [active, setActive] = useState(url.pathname.substring(url.pathname.lastIndexOf("/") + 1).toLowerCase())
    const downMd = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));

    const handleActiveMainMenu = (menuItem: any) => () => {
        setActive(menuItem.title.toLowerCase())
        navigate(menuItem.path)
        closeMobileSideBar()
    }

    // main menus content
    const mainSideBarContent = (
        <List sx={{height: "100%"}}>
            <Box component={"a"} display={"flex"} paddingY={1} justifyContent={"center"}
                 href={"/dashboard"} width={"100%"}>
                <img src={"/static/logo/full_logo.png"} alt="ReddoPay Logo" width={120}/>
            </Box>

            <ScrollBar style={{maxHeight: "calc(100% - 50px)"}}>
                {topMenuList.map((nav, index) => {
                    return <Tooltip title={nav.title} placement="right" key={index}>
                        <StyledListItemButton
                            disableRipple
                            sx={{
                                backgroundColor: active === nav.title.toLowerCase() ? "primary.50" : "initial",
                                "&:hover": {backgroundColor: active === nav.title.toLowerCase() ? "primary.50" : "white.800"},
                            }}
                            onClick={handleActiveMainMenu(nav)}>

                            <Stack direction={"row"} gap={2} width={"100%"} alignItems={"center"}>
                                <nav.Icon
                                    sx={{
                                        color: "primary.main",
                                    }}
                                />
                                <H4>{nav.title}</H4>
                            </Stack>

                        </StyledListItemButton>
                    </Tooltip>

                })}
            </ScrollBar>
        </List>
    )

    // for mobile device
    if (downMd) {
        return (
            <Drawer
                anchor="left"
                open={showMobileSideBar}
                onClose={closeMobileSideBar}
                PaperProps={{sx: {width: 220}}}>
                <Box
                    sx={{
                        height: "100%",
                        display: "flex",
                        width: "inherit",
                        position: "fixed",
                        overflow: "hidden",
                        flexDirection: "column",
                        boxShadow: (theme) => theme.shadows[1],
                        backgroundColor: (theme) => theme.palette.background.paper,
                        "& .simplebar-track.simplebar-vertical": {width: 7},
                        "& .simplebar-scrollbar:before": {
                            background: (theme) => theme.palette.text.primary,
                        },
                    }}>
                    {mainSideBarContent}
                </Box>
            </Drawer>
        )
    }

    return <MainMenu>{mainSideBarContent}</MainMenu>
}

export default DashboardSideBar
